import {
  DEFAULT_DENSITY,
  DEFAULT_EFFECTS,
  DEFAULT_SHAPE,
  DEFAULT_TYPOGRAPHY,
  FALLBACK_TOKENS,
} from "./meta";
import type { ThemeTemplate } from "./types";

export type ThemeMode = "dark" | "light";

export interface ThemeStateLocal {
  dark: Record<string, string>;
  light: Record<string, string>;
  effects: Record<string, number>;
  typography: { serif: string; sans: string; mono: string };
  shape: { radius: number };
  density: { pad: number; gap: number };
}

/**
 * Construye un state local editable a partir de los tokens persistidos en
 * la plantilla. Tolerante: si la plantilla no tiene algún sub-objeto, usa
 * el fallback. Indispensable porque las plantillas viejas pueden venir
 * incompletas.
 */
export function buildLocalStateFromTemplate(tpl: ThemeTemplate): ThemeStateLocal {
  const tokens = (tpl.tokens ?? {}) as Record<string, any>;
  return {
    dark: { ...FALLBACK_TOKENS.dark, ...(tokens.dark ?? {}) },
    light: { ...FALLBACK_TOKENS.light, ...(tokens.light ?? {}) },
    effects: { ...DEFAULT_EFFECTS, ...(tokens.effects ?? {}) },
    typography: { ...DEFAULT_TYPOGRAPHY, ...(tokens.typography ?? {}) },
    shape: { ...DEFAULT_SHAPE, ...(tokens.shape ?? {}) },
    density: { ...DEFAULT_DENSITY, ...(tokens.density ?? {}) },
  };
}

/**
 * Serializa el state local a la forma que espera el backend (PUT /templates).
 */
export function serializeToTokens(state: ThemeStateLocal): Record<string, any> {
  return {
    dark: state.dark,
    light: state.light,
    effects: state.effects,
    typography: state.typography,
    shape: state.shape,
    density: state.density,
  };
}

/**
 * Compara dos states para saber si hay cambios sin guardar (dirty flag).
 */
export function statesEqual(a: ThemeStateLocal, b: ThemeStateLocal): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
